import Logo from "@/components/Logo";
import { useTenantBrand } from "@/components/TenantBrandProvider";
import { sanitizeBrandUrl } from "@/lib/tenant-brand";

/** Tenant logo alongside AivoryEMS — used in cobrand mode and marketing contexts. */
export default function CoBrandLogo({ size = 22, showWordmark = true, className = "" }) {
  const { brand } = useTenantBrand();

  if (brand.enabled && brand.mode === "full") {
    if (brand.logoUrl) {
      const logoSrc = sanitizeBrandUrl(brand.logoUrl);
      if (logoSrc) {
        return (
          <div className={`flex items-center gap-2.5 min-w-0 ${className}`}>
            <img src={logoSrc} alt={brand.productName} className="object-contain" style={{ height: size, maxWidth: size * 4 }} />
            {showWordmark ? (
              <span className="font-heading text-[var(--text-primary)] font-semibold tracking-tight text-base truncate">
                {brand.productName}
              </span>
            ) : null}
          </div>
        );
      }
    }
    return (
      <span className={`font-heading font-semibold tracking-tight text-base truncate ${className}`}>
        {brand.productName}
      </span>
    );
  }

  const accent = brand.colors?.primary || "var(--primary)";

  if (brand.enabled && brand.logoUrl) {
    const logoSrc = sanitizeBrandUrl(brand.logoUrl);
    if (!logoSrc) return <Logo size={size} showWordmark={showWordmark} accent={accent} className={className} />;
    return (
      <div className={`flex items-center gap-3 min-w-0 ${className}`} data-testid="cobrand-logo">
        <img src={logoSrc} alt={brand.productName} className="object-contain shrink-0" style={{ height: size, maxWidth: size * 3 }} />
        <span className="text-[var(--text-tertiary)] font-light text-lg leading-none select-none" aria-hidden="true">|</span>
        <Logo size={size} showWordmark={showWordmark} accent={accent} />
      </div>
    );
  }

  return <Logo size={size} showWordmark={showWordmark} accent={accent} className={className} />;
}
